export default __webpack_public_path__ + "static/media/html_css.ea7ec14f.png";